import { motion } from 'framer-motion';
import { Handshake } from '@phosphor-icons/react';

/**
 * ClientsPartnersSection
 * --------------------------------------------------------------
 * Hidden section — prepared structure for future activation.
 *
 * HOW TO ENABLE IN THE FUTURE:
 *   1. In `src/components/featureFlags.js` set:
 *        SHOW_CLIENTS_PARTNERS: true
 *   2. Replace the `LOGOS` array below with the real client / partner data
 *      (logo URL, name, optional link). Make sure to obtain written
 *      approval from each entity before listing them publicly.
 *   3. Save & redeploy. The section will appear automatically on the homepage.
 *
 * The section is fully styled and accessibility-ready; only logos and the
 * `enabled` flag need to be flipped.
 * --------------------------------------------------------------
 */

// Placeholder data — replace with real approved logos before activation.
const LOGOS = [
  // { name: 'الجهة 1', logo: '/partners/logo1.png', href: 'https://...' },
];

const ClientsPartnersSection = () => (
  <section
    id="clients-partners"
    data-testid="clients-partners-section"
    className="py-20 bg-white"
    dir="rtl"
  >
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <span className="inline-block px-4 py-1.5 rounded-full border border-[#D8D2C8] text-[#5D6E55] text-xs sm:text-sm mb-4">
          شركاء النجاح
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-[#1F3D2B] mb-3 font-['IBM_Plex_Sans_Arabic']">
          عملاؤنا وشركاؤنا
        </h2>
        <p className="text-[#6B7565] max-w-2xl mx-auto leading-8">
          نفخر بثقة الجهات التي تعاملنا معها في تطوير خدمات الطفولة المبكرة.
        </p>
      </motion.div>

      {LOGOS.length === 0 ? (
        <div className="text-center text-sm text-[#92A082]" data-testid="clients-partners-empty">
          سيتم عرض الشعارات هنا قريباً.
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 items-center">
          {LOGOS.map((c) => (
            <a
              key={c.name}
              href={c.href || '#'}
              target={c.href ? '_blank' : undefined}
              rel="noreferrer"
              className="group bg-[#FAFAF7] border border-[#E6E0D6] rounded-2xl p-5 flex items-center justify-center h-24 hover:border-[#4A641F] transition-colors"
            >
              <img
                src={c.logo}
                alt={c.name}
                className="max-h-12 max-w-full object-contain grayscale group-hover:grayscale-0 transition"
              />
            </a>
          ))}
        </div>
      )}

      <div className="flex items-center justify-center gap-2 mt-10 text-xs text-[#92A082]">
        <Handshake size={16} weight="duotone" className="text-[#4A641F]" />
        <span>شراكات مبنية على الجودة والثقة المتبادلة</span>
      </div>
    </div>
  </section>
);

export default ClientsPartnersSection;
